<table class="utilization-in-period-table" width="100%">
    <thead>
	    <tr class="c-text--dark-gray c-text--sm">
	        <th scope="col"></th>
	        <th scope="col">{{'Hr_Dashboard.Table_Usage_Statistics.Psychologists' | translate}}</th>
	        <th scope="col">{{'Hr_Dashboard.Table_Usage_Statistics.Coaches' | translate}}</th>
	        <th scope="col">{{'Hr_Dashboard.Table_Usage_Statistics.Total' | translate}}</th>
	        <th scope="col">{{'Hr_Dashboard.Table_Usage_Statistics.Changes' | translate}}</th>
	    </tr>
    </thead>
    <tbody>
	    <tr>
	        <td colspan="5" class="divider">
	            <hr />
	        </td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{'Hr_Dashboard.Table_Usage_Statistics.Completed_Sessions' | translate}}</th>
	        <td>{{vm.getReportSessionDescriptor('COMPLETED')['psychoSessionCount'] || 0}}</td>
	        <td>{{vm.getReportSessionDescriptor('COMPLETED')['coachSessionCount'] || 0}}</td>
	        <td>{{(vm.getReportSessionDescriptor('COMPLETED')['psychoSessionCount'] || 0) + (vm.getReportSessionDescriptor('COMPLETED')['coachSessionCount'] || 0)}}</td>
	        <td>{{vm.getReportSessionDescriptor('COMPLETED')['changeComparedToLastPeriod'] || 0}}%</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{'Hr_Dashboard.Table_Usage_Statistics.First_Time_Sessions' | translate}}</th>
	        <td>{{vm.getReportSessionDescriptor('FIRST_TIME')['psychoSessionCount'] || 0}}</td>
	        <td>{{vm.getReportSessionDescriptor('FIRST_TIME')['coachSessionCount'] || 0}}</td>
	        <td>{{(vm.getReportSessionDescriptor('FIRST_TIME')['psychoSessionCount'] || 0) + (vm.getReportSessionDescriptor('FIRST_TIME')['coachSessionCount'] || 0)}}</td>
	        <td>{{vm.getReportSessionDescriptor('FIRST_TIME')['changeComparedToLastPeriod'] || 0}}%</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{'Hr_Dashboard.Table_Usage_Statistics.Follow_Up_Sessions' | translate}}</th>
	        <td>{{vm.getReportSessionDescriptor('FOLLOW_UP')['psychoSessionCount'] || 0}}</td>
	        <td>{{vm.getReportSessionDescriptor('FOLLOW_UP')['coachSessionCount'] || 0}}</td>
	        <td>{{(vm.getReportSessionDescriptor('FOLLOW_UP')['psychoSessionCount'] || 0) + (vm.getReportSessionDescriptor('FOLLOW_UP')['coachSessionCount'] || 0)}}</td>
	        <td>-</td>
	    </tr>
	    <tr class="c-text--sm">
	        <th scope="row">{{'Hr_Dashboard.Table_Usage_Statistics.Contacts' | translate}}</th>
	        <td>{{vm.generatedPreview ? vm.generatedPreview.summaryEntriesPerCustomer || 0 : 0}}</td>
	        <td>-</td>
	        <td>-</td>
	        <td>-</td>
	    </tr>
    </tbody>
</table>
